var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNaveSombra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 291 17.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#Gradiente_sem_nome);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome",
    "data-name": "Gradiente sem nome",
    x1: -29.54,
    y1: 132.69,
    x2: 177.1,
    y2: -203.67,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -137.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f26e1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d81b55"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ativo 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,16.5s291,3,291-3.33S96.5,0,96.5,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaveSombra);
export default __webpack_public_path__ + "static/media/nave-sombra.58da098e49fe85c4126244cdaf999e08.svg";
export { ForwardRef as ReactComponent };